import CMSRender from "aldoo-ra/CMS/cms-render"
import Typography from "aldoo-ra/Typography"
import parse from "html-react-parser"
import React, { useRef } from "react"
import TopRightPageBg from "../Site/TopRightPageBg"
import AppDownloadCTAPlatforms from "./app-download-cta-platforms"
import BackToTopButton from "./back-to-top-btn"
import SquareBanner from "./banner"
import ReadTimeBadge from "./read-time-badge"
import BlogSharePanel from "./share-panel"
// Import the updateCDNUrls function from the BlogEditor
import { updateCDNUrls } from "aldoo-ra/Blog/Editor"

const BlogPost = ({ postID }) => {
  const contentRef = useRef(null)
  return (
    <div className="w-full bg-gradient_bottom_page rounded-b-[50px] md:rounded-b-[100px] overflow-hidden">
      <CMSRender
        contentType="BlogPost"
        match={{ "content.slug": postID }}
        renderItem={(post, id) => {
          // Create reusable draft chip component
          const DraftChip = () => (
            <span className="bg-admin_warning text-admin_text_inv rounded-full px-3 py-1.5 font-medium text-sm inline-block">
              Draft Article
            </span>
          )

          return (
            <div
              key={id}
              className="w-full md:max-w-[700px] lg:max-w-w2_xl px-4 md:px-px1_l pt-10 md:pt-[60px] lg:pt-[107px] pb-[108px] md:pb-[168px] mx-auto"
            >
              <BackToTopButton />
              {/* Title and Date */}
              <div className="lg:max-w-[1200px] mb-[48px] mx-autolg:mx-0">
                {/* Draft Chip - Only shown when post is in draft mode */}
                {post.status === "draft" && (
                  <div className="mb-4">
                    <DraftChip />
                  </div>
                )}
                <Typography
                  component="h1"
                  variant="h2"
                  className="text-left mb-[16px]"
                >
                  {post.title}
                </Typography>
                {/* Date */}
                <Typography variant="txt1_dim">
                  {new Date(post.publish_date || post.created_date || "2024-01-01").toLocaleDateString("en", {
                    day: "numeric",
                    month: "long",
                    year: "numeric",
                  })}
                </Typography>
              </div>
              {/* Article Layout - Left and Right Columns*/}
              <div className="w-full flex flex-col lg:flex-row items-center lg:items-start justify-between gap-[88px] lg:gap-12 xl:gap-[40px]">
                {/* Left Column - Main Content */}
                <div className="w-full lg:min-w-[540px] xl:min-w-[670px] lg:max-w-[750px] xl:max-w-[890px] flex-1">
                  {/* Featured Image */}
                  <div className="rounded-[28px] md:rounded-[50px] overflow-hidden mb-[30px] relative">
                    <div className="relative">
                      <img
                        src={post.thumbnail}
                        alt={post.title}
                        className="w-full aspect-[694/428] xl:aspect-[890/428] object-cover"
                      />
                      {/* Read Time Badge */}
                      <ReadTimeBadge
                        data={post}
                        top="4"
                        topMd="6"
                        right="4"
                        rightMd="8"
                      />
                    </div>
                  </div>

                  <div className="mb-10">
                    <BlogSharePanel url={typeof window !== 'undefined' ? window.location.href : ''} title={post.title} />
                  </div>

                  {/* Article Content */}
                  <article ref={contentRef} className="blog_post">
                    {parse(
                      post.content ? updateCDNUrls(post.content) : "Empty"
                    )}
                  </article>

                  {/* Second Draft Chip after content - Only shown when post is in draft mode */}
                  {post.status === "draft" && (
                    <div className="mt-8 mb-2 text-center">
                      <DraftChip />
                    </div>
                  )}

                  <div className="mt-[96px]">
                    <BlogSharePanel url={typeof window !== 'undefined' ? window.location.href : ''} title={post.title} />
                  </div>
                </div>
                {/* Right Column - Sidebar */}
                <div className="hidden lg:block w-full lg:w-[423px] xl:w-[510px] flex-shrink-0">
                  <div>
                    {/* Download Banner */}
                    <SquareBanner />
                    {/* Related Posts - temporarily hidden for site v1.0*/}
                    {/* <RelatedPosts post={post} numberOfRelated={3} /> */}
                  </div>
                </div>
              </div>
              {/* Divider */}
              <div className="w-full h-[1px] bg-gray_200 mt-[110px] mb-[88px]" />
              <AppDownloadCTAPlatforms />
            </div>
          )
        }}
      />
      <TopRightPageBg />
    </div>
  )
}
export default BlogPost
